import type React from 'react';

import formatInTimeZone from 'date-fns-tz/formatInTimeZone';
import ru from 'date-fns/locale/ru';
import parseISO from 'date-fns/parseISO';

import { useConsultation } from '@src/entities/consultations';

type Props = {
	id: number;
};

export const ConsultationDate: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	return (
		<>
			{consultation &&
				formatInTimeZone(parseISO(consultation.start_time), 'Europe/Moscow', 'dd MMMM yyyy', {
					locale: ru,
				})}
		</>
	);
};
